import { configureStore, combineReducers } from "@reduxjs/toolkit";
import storeReducer from "./storeRedux";
import cartRedux from "./cartRedux";
import settingsRedux from "./settingsRedux";
import { metaPixelCartMiddleware } from "./metaPixelCartMiddleware.js";
import { webAnalyticsCartMiddleware } from "./webAnalyticsCartMiddleware.js";

import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist'
import storage from "redux-persist/lib/storage";

const persistConfig = {
  key: 'root',
  version: 1,
  storage,
}

const rootReducer = combineReducers({ 
  store: storeReducer,
  cart: cartRedux, 
  settings: settingsRedux
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(metaPixelCartMiddleware, webAnalyticsCartMiddleware),
});

export let persistor = persistStore(store);
